
























import Vue from 'vue';

export default Vue.extend({
  props: {
    title: { type: String, default: undefined },
    message: { type: String, default: undefined },
    type: { type: String, default: 'base' },
  },
  methods: {
    close(value: boolean) {
      this.$emit('input', value);
      this.$el.remove();
      this.$destroy();
    },
  },
});
